/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Directory_Submit_Enrich_Draft_SavedInputs */

const en_directory_submit_enrich_draft_saved = /** @type {(inputs: Directory_Submit_Enrich_Draft_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Draft saved: '${i?.slug}' — choose a plan to submit it for review.`)
};

const zh_directory_submit_enrich_draft_saved = /** @type {(inputs: Directory_Submit_Enrich_Draft_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`草稿已保存：'${i?.slug}' — 选择方案后提交审核。`)
};

/**
* | output |
* | --- |
* | "Draft saved: '{slug}' — choose a plan to submit it for review." |
*
* @param {Directory_Submit_Enrich_Draft_SavedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_draft_saved = /** @type {((inputs: Directory_Submit_Enrich_Draft_SavedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Draft_SavedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_draft_saved(inputs)
	return zh_directory_submit_enrich_draft_saved(inputs)
});
export { directory_submit_enrich_draft_saved as "directory.submit.enrich.draft_saved" }